// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__gEj2b","indicator":"checkbox_indicator__iEac3","label":"checkbox_label__-nmZD"};